var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"5d9b326e3267affb2945bc2fceb516f6d5864671"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["resume@chump"]={id:"5d9b326e3267affb2945bc2fceb516f6d5864671"};
      